import ApiConstants from '../../constants/ApiConstants';
import checkResults from './checkResults.js';
import xhr from './xhr';

const TimeZoneApiUtils = {
  fetch() {
    return xhr(ApiConstants.FetchTimezones).then(checkResults);
  },
};

export default TimeZoneApiUtils;
